// @ts-nocheck
import React, { useState } from 'react';
import { Form, Input, Button, Row, message, Popover } from 'antd';
import { isChinaMobile } from '@ywfe/utils';
import { YAuthProps } from './auth.interface';
import { useSetInterval } from '../hooks';
import { usePostAPI19969, usePostAPI20088 } from '../generated/api';
import { CodeBtnStyle, ToolWrapStyle } from './styles';

export const ResetPassword: React.FC<YAuthProps> = (props: YAuthProps) => {
  const { onChangeType } = props;
  const [disabled, setDisabled] = useState(false);
  const [second, setSecond] = useState(60);
  const [delay, setDelay] = useState<number>(null as unknown as number);
  const [form] = Form.useForm();

  const { fetchAPI19969Data } = usePostAPI19969();
  const { fetchAPI20088Data } = usePostAPI20088();

  useSetInterval(() => {
    if (second <= 0) {
      return () => {
        setDelay(null as unknown as number);
        setSecond(60);
        setDisabled(false);
      };
    }
    setSecond(second - 1);
  }, delay);

  const toSendCode = async () => {
    try {
      const values = await form.validateFields(['telephone']);
      const res = await fetchAPI19969Data({
        telephone: values.telephone,
        codeType: 'RESET_PWD',
      });
      if (res) {
        setDisabled(true);
        setDelay(1000);
      }
    } catch (error) {
      const { errorFields } = error;
    }
  };

  const onFinish = async (values: any) => {
    // if (values.passWd !== values.passWdAg) {
    //   message.error('密码输入不一致！');
    //   return;
    // }
    // const reg = new RegExp(/(?=.*[a-z])(?=.*\d)(?=.*[#@!~%^&*])[a-z\d#@!~%^&*]{8,}/i);
    // if (!reg.test(values.passWd)) {
    //   message.error('密码至少8位，要求必须字母、数字、特殊符号（英文版本：~!@#$%^&*）！');
    //   return;
    // }
    const res = await fetchAPI20088Data({
      telephone: values.telephone,
      passWd: (window as any).md5(values.passWd),
      mtCode: values.mtCode,
    });
    if (res) {
      onChangeType && onChangeType();
      message.success('重置成功');
    }
  };

  return (
    <>
      <div
        className="back"
        onClick={() => {
          onChangeType && onChangeType();
        }}
      >
        重置密码
      </div>
      <Form form={form} onFinish={onFinish}>
        <Form.Item
          name="telephone"
          rules={[
            {
              validator: (_: any, value: string | number) =>
                isChinaMobile(value) ? Promise.resolve() : Promise.reject('手机号码格式错误，请重新输入'),
            },
          ]}
        >
          <Input maxLength={20} placeholder="请输入手机号码" />
        </Form.Item>
        <Form.Item>
          <Row gutter={2}>
            <Form.Item name="mtCode" rules={[{ required: true, message: '请输入验证码!' }]} noStyle>
              <Input
                maxLength={6}
                placeholder="验证码"
                suffix={
                  <CodeBtnStyle type="link" disabled={disabled} onClick={toSendCode}>
                    {second === 60 ? '发送验证码' : `${second}秒后发送`}
                  </CodeBtnStyle>
                }
              />
            </Form.Item>
          </Row>
        </Form.Item>
        <Form.Item
          name="passWd"
          rules={[
            { required: true, message: '请输入新密码!' },
            {
              pattern: /(?=.*[a-z])(?=.*\d)(?=.*[#@!~%^&*])[a-z\d#@!~%^&*]{8,}/i,
              message: '密码至少8位，要求必须字母、数字、特殊符号',
              validateTrigger: 'onBlur',
            },
          ]}
        >
          <div>
            <Input.Password placeholder="新密码" autoComplete="new-password" />
          </div>
        </Form.Item>
        <Form.Item
          name="passWdAg"
          rules={[
            {
              validator: (rule, value) =>
                new Promise((resolve, reject) => {
                  if (!value) {
                    reject('请输入新密码!');
                  }
                  if (value !== form.getFieldValue('passWd')) {
                    reject('密码输入不一致！');
                  } else {
                    resolve('');
                  }
                }),
            },
          ]}
        >
          <Input.Password placeholder="密码确认" autoComplete="new-password" />
        </Form.Item>
        <Button size="large" type="primary" htmlType="submit" style={{ marginTop: '14px' }} block>
          重置
        </Button>
        {/* <ToolWrapStyle>
          <span />
          <Button type="link" onClick={() => onChangeType && onChangeType()}>
            登录
          </Button>
        </ToolWrapStyle> */}
      </Form>
    </>
  );
};
